import React from "react";
import history from "./Routes/history";

export default class TKLErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { error: null, errorInfo: null, hasError: false };
    this.unlisten = null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidMount() {
    this.unlisten = history.listen(() => {
      if (this.state.hasError) {
        this.setState({ hasError: false, error: null, errorInfo: null });
      }
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // Always log so "Something went wrong" reports can be diagnosed from the console.
    console.error("TKLErrorBoundary caught:", error, errorInfo);
    // PL-24: report to Rollbar when available (prod snippet)
    try {
      if (typeof window !== "undefined" && window.Rollbar) {
        window.Rollbar.error(error, { reactErrorInfo: errorInfo });
      }
    } catch (e) {
      // ignore reporting failures
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="pg-main pb-3 pb-md-5">
          <div className="container py-5 text-center">
            <h1 className="h3">Something went wrong</h1>
            <p className="text-muted mb-3">
              Please refresh the page. If the problem continues, contact support.
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Refresh
            </button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
